import { render } from "./RootTreeView.vue?vue&type=template&id=ddf4e20a"
import script from "./RootTreeView.vue?vue&type=script&lang=js"
export * from "./RootTreeView.vue?vue&type=script&lang=js"

import exportComponent from "/home/jhg/tagforest/tagforest-frontend-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__